import CoverDefaultSrc from '@/assets/cover-default.png';
import { PauseIcon, PlayIcon } from '@/components/Icons';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { NextTrackIcon } from '@/components/Icons/NextTrackIcon';
import { StoreState, useAudioPlayerStore } from '@/state/audio-player-store';
import { cn } from '@/utils';
import React, { useCallback, useEffect, useState } from 'react';

interface MiniPlayerUIProps {
  audioPlayerStore: StoreState;
  className?: string;
}

export const MiniPlayerUI: React.FC<MiniPlayerUIProps> = ({ audioPlayerStore, className }) => {
  const { isLoading, isPlaying, play, pause, playAudioInfo, onNext, wave } = audioPlayerStore;
  const currentTime = audioPlayerStore.currentTime;
  if (!audioPlayerStore.playAudioInfo) {
    return null;
  }
  const [bufferTime, setBufferTime] = useState(0);
  const audioElement = wave?.wavesurfer?.getMediaElement();
  useEffect(() => {
    const handleProgress = () => {
      if (audioElement && audioElement.buffered.length > 0) {
        const bufferedEnd = audioElement.buffered.end(audioElement.buffered.length - 1);
        setBufferTime(bufferedEnd);
      }
    };

    if (audioElement) {
      audioElement.addEventListener('progress', handleProgress);
    }

    return () => {
      if (audioElement) {
        audioElement.removeEventListener('progress', handleProgress);
      }
    };
  }, [audioElement]);
  const handleChangeDuration = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      if (!audioPlayerStore?.playAudioInfo?.duration) return;

      const rect = e.currentTarget.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const width = rect.width;
      const percentage = clickX / width;
      const newTime = percentage * audioPlayerStore.playAudioInfo.duration;
      wave?.wavesurfer?.setTime(newTime);
    },
    [bufferTime],
  );
  return (
    <div
      className={cn(' overflow-hidden relative w-full h-[64px] border border-jen-border rounded-jen-spacing-8 cursor-pointer', className)}
      onClick={(e) => handleChangeDuration(e)} // 点击事件
    >
      <div
        style={{
          width: `${bufferTime && audioPlayerStore?.playAudioInfo?.duration ? ((bufferTime / audioPlayerStore?.playAudioInfo?.duration) * 100).toFixed(2) : 0}%`,
        }}
        className="cursor-pointer w-full h-full bg-[#0000001A] absolute left-0 top-0 "
      ></div>
      <div
        style={{
          width: `${currentTime && audioPlayerStore?.playAudioInfo?.duration ? ((currentTime / audioPlayerStore?.playAudioInfo?.duration) * 100).toFixed(2) : 0}%`,
        }}
        className="w-full h-full bg-[#FF5B2733] absolute left-0 top-0 "
      ></div>
      <div className="relative w-full h-full items-center p-[6px]  gap-[10px] flex">
        <img className="h-full mr-jen-spacing-8" src={CoverDefaultSrc} />
        <div className=" truncate flex-1">{audioPlayerStore?.playAudioInfo?.name || ''}</div>

        {/* <ShareIcon /> */}
        <div
          className=" rounded-full w-[32px] h-[32px]   flex justify-center items-center"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {isLoading ? (
            <LoadingIcon className="animate-spin" />
          ) : isPlaying ? (
            <PauseIcon className=" cursor-pointer" onClick={() => pause()} />
          ) : (
            <PlayIcon className=" cursor-pointer" onClick={() => play(playAudioInfo)} />
          )}
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            onNext();
          }}
        >
          <NextTrackIcon className="cursor-pointer" />
        </div>
      </div>
    </div>
  );
};

const MiniPlayer: React.FC<{ className?: string }> = ({ className }) => {
  const audioPlayerStore = useAudioPlayerStore();
  return <MiniPlayerUI className={className} audioPlayerStore={audioPlayerStore} />;
};

export default MiniPlayer;
